import ApiClient from 'dashboard/api/ApiClient';

const canonicalMetaAuthApi = new ApiClient('profile/canonical_meta_handoff');

const metaAuthOrigin = () => {
  const metaAuthURL =
    window.lumeratecConfig?.metaAuthURL || window.lumeratecConfig?.hostURL;
  return metaAuthURL ? new URL(metaAuthURL).origin : window.location.origin;
};

export const isCanonicalMetaHost = () => {
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.origin === metaAuthOrigin()
  );
};

export const redirectToCanonicalMetaHost = async () => {
  if (isCanonicalMetaHost()) return false;

  const returnPath = `${window.location.pathname}${window.location.search}`;
  const response = await canonicalMetaAuthApi.create({
    return_path: returnPath,
  });
  window.location.assign(response.data.url);
  return true;
};
